import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="border-t border-border mt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-7 h-7 bg-foreground text-background grid place-items-center font-serif-display text-lg font-black">D</div>
            <span className="font-serif-display text-xl tracking-tight">DocuMind</span>
          </div>
          <p className="text-sm text-muted-foreground max-w-xs">Chat with any PDF. Built for researchers, legal teams, and curious minds.</p>
        </div>
        <div>
          <div className="font-mono-label text-muted-foreground mb-4">Product</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#features">Features</a></li>
            <li><a href="/#pricing">Pricing</a></li>
            <li><Link to="/signup">Start free</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono-label text-muted-foreground mb-4">Compare</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/compare/chatpdf">vs ChatPDF</Link></li>
            <li><Link to="/compare/askyourpdf">vs AskYourPDF</Link></li>
            <li><Link to="/compare/humata">vs Humata</Link></li>
            <li><Link to="/compare/pdfai">vs PDF.ai</Link></li>
            <li><Link to="/compare">All comparisons →</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-mono-label text-muted-foreground mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><a href="mailto:hello@documind.app">Contact</a></li>
            <li><a href="#">Privacy</a></li>
            <li><a href="#">Terms</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-6 text-center text-xs text-muted-foreground font-mono-label">
        © {new Date().getFullYear()} DocuMind — A rebuild for demo purposes.
      </div>
    </footer>
  );
}
